/**
 * ModeBadge — primitive Editorial Operations (HiFi.3).
 *
 * Petite signature contextuelle posée en tête d'écran :
 *   ● FAMILLE MARTIN   (mode classique → dot sage)
 *   ● CAMILLE & JULIEN (mode coparenting → dot slate)
 *
 * Utilisé dans EditorialHero et dans la sidebar desktop. Le dot
 * reprend la couleur signature de la palette ; le kicker en uppercase
 * est en `--ink-soft` pour rester discret face au titre hero.
 */
import { html, type TemplateResult } from 'lit-html';
import styles from './editorial.module.css';
import type { HomeMode } from '@nestor/shared-types';

export interface ModeBadgeProps {
  /** Mode du foyer courant — pilote la couleur du dot. */
  mode: HomeMode;
  /** Libellé affiché en uppercase. Typiquement `home.name`. */
  label: string;
}

export function modeBadge({ mode, label }: ModeBadgeProps): TemplateResult {
  const dotColor = mode === 'coparenting' ? 'var(--slate)' : 'var(--sage)';
  return html`<div class=${styles.modeBadge} data-testid="mode-badge-kicker">
    <span class=${styles.modeBadgeDot} style="background: ${dotColor}"></span>
    <span class="kicker">${label}</span>
  </div>`;
}
